// extracted by mini-css-extract-plugin
export default {"modal":"Vea-z","modalContent":"Wea-z","footer":"Xea-z","cancelBtn":"Yea-z","disabled":"Zea-z","formWrapper":"_ea-z","fade":"afa-z","fade-in":"bfa-z","iframe":"cfa-z"};